import axios from 'axios';

const BASE_URL = 'https://middleware.dev-dttsynergy.com/api';

const metricsAxios = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

metricsAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('unified_videowall_cascais_token');
  if (token) config.headers['Authorization'] = token;
  return config;
});

/**
 * Fetch metric data for a single item.
 *
 * @param {string}  itemId      — device UUID
 * @param {string}  periodicity — DAILY | HOURLY | WEEKLY | MONTHLY
 * @param {string}  startDate   — ISO string
 * @param {string}  endDate     — ISO string
 * @returns {Promise<any>}      — raw API response data
 */
export const fetchMetrics = async (itemId, periodicity, startDate, endDate) => {
  const response = await metricsAxios.get('/metrics', {
    params: { id: itemId, periodicity, startDate, endDate },
  });
  return response.data;
};
